import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="pt-28 bg-white min-h-[70vh] flex items-center">
      <Seo title="Page Not Found | Zarco's Decks & Outdoor Living" description="This page doesn't exist. Browse Zarco's Decks services, gallery, or request a free estimate." />
      <section className="px-6 md:px-12 lg:px-20 py-20 max-w-2xl">
        <p className="text-xs uppercase tracking-[0.3em] text-[#99582A] font-semibold">404</p>
        <h1 className="font-display text-4xl md:text-5xl tracking-tight font-medium mt-4 text-[#111]">
          This page took a walk off the deck.
        </h1>
        <p className="mt-4 text-[#4A4A4A] leading-relaxed">
          The page you're looking for doesn't exist. Head back home, browse the
          gallery, or start your free estimate.
        </p>
        <div className="mt-8 flex flex-wrap gap-4">
          <Link to="/" data-testid="notfound-home-btn" className="inline-flex items-center gap-2 bg-[#111] text-white px-7 py-4 font-semibold tracking-wide hover:bg-[#99582A] transition-colors">
            <ArrowLeft size={16} /> Back to Homepage
          </Link>
          <Link to="/contact" data-testid="notfound-estimate-btn" className="border-2 border-[#111] px-7 py-4 font-semibold tracking-wide hover:bg-[#111] hover:text-white transition-colors">
            Get Your Free Estimate
          </Link>
        </div>
      </section>
    </div>
  );
}
